import { Model } from '@vuex-orm/core'
import Article from '@models/helpers/Article'

export default class ArticlesHasAccessorygroup extends Model{
  static entity = 'articlesHasAccessorygroups'
  static fields () {
    return {
      id: this.attr(null),
      accessorygroups_id: this.attr(null),
      articles_id: this.attr(null),
      sort_index: this.attr(null),

      article: this.belongsTo(Article, 'articles_id'),
    }
  }
}
  